import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { ToastContainer } from "react-toastify"; // ✅ Keep toast notifications
import "react-toastify/dist/ReactToastify.css"; // ✅ Import toast styles

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
      <ToastContainer autoClose={5000} position="bottom-right" /> {/* ✅ Keep ToastContainer */}
    </BrowserRouter>
  </React.StrictMode>
);
